(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('InitiativeUpdateStatusAssessByQuarterDeliverablesController', Controller);

    Controller.$inject = ['$scope', 'topBarService', 'govProcess', 'assessmentByInitiative', 'deliverableAssessmentsByQuarter', 'fiscalYearQuarterKeys', 'planLookups'];

    function Controller($scope, topBarService, govProcess, assessmentByInitiative, deliverableAssessmentsByQuarter, fiscalYearQuarterKeys, planLookups) {

        topBarService.setTitleAndIcon('Business Planning', 'fa fa-compass');
        $scope.govProcess = govProcess;

        //console.log(deliverableAssessmentsByQuarter);

        $scope.ctrlCtxt                                 = {};
        $scope.ctrlCtxt.planLookups                     = planLookups;

        $scope.initiativesList = assessmentByInitiative.InitiativesList;
        $scope.planInitiative = assessmentByInitiative.PlanInitiative;
        $scope.planInitiativeAssessment = assessmentByInitiative.PlanInitiativeAssessment;
        $scope.assessmentByInitiative = _.omit(assessmentByInitiative, 'PlanDeliverableAssessments');
        $scope.deliverableAssessmentsByQuarter          = deliverableAssessmentsByQuarter;
        $scope.fiscalYearQuarterKeys                    = fiscalYearQuarterKeys;

        $scope.canEdit = false;
        if (assessmentByInitiative && assessmentByInitiative.PlanInitiative) {
            $scope.canEdit = assessmentByInitiative.PlanInitiative.IsOwner || assessmentByInitiative.PlanInitiative.IsOwnerDelegate;
        }
    }
})();